export enum CallbackRequestStatus {
  ToDo = 'TODO',
  InProgress = 'IN_PROGRESS',
  Done = 'DONE',
}
